import { render, staticRenderFns } from "./CentroPop.vue?vue&type=template&id=1d6740ac"
import script from "./CentroPop.vue?vue&type=script&lang=js"
export * from "./CentroPop.vue?vue&type=script&lang=js"
import style0 from "./CentroPop.vue?vue&type=style&index=0&id=1d6740ac&prod&lang=css"
import style1 from "./CentroPop.vue?vue&type=style&index=1&id=1d6740ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports